import React from 'react';

import {BulkActionTool} from 'src/components/bulk-tool';
import {
    getUpdateRelationsProgress,
    stopBulkAction,
    updateAccountManagerBulk,
} from 'src/openapi/admin/apis/AccountManagerBulkApi';
import {useAppDispatch} from 'src/store/hooks';

import {
    TOOL_PROGRESS_LABEL,
    TOOL_STACK_OVERFLOW_MESSAGE,
    TOOL_TASK,
    TOOL_TITLE,
} from './constants';
import {UpdateAccountTeamMemberModal} from './update-account-team-member.modal';
import {
    selectAccountManagerUpdateTask,
    selectAccountManagerUpdateUuid,
    setBackgroundTask,
    setShown,
    setUuid,
} from './update-account-team-member.slice';

import type {AssignAccountManagerRequest} from 'src/openapi/admin/models/AssignAccountManagerRequest';

type Props = {
    shown: boolean,
    accountIds: number[],
    onDone: () => void,
    onClose: () => void,
};

export const UpdateAccountTeamMemberTool = ({shown, accountIds, onDone, onClose}: Props) => {
    const apiDispatch = useAppDispatch();

    return (
        <BulkActionTool<AssignAccountManagerRequest[]>
            shown={shown}
            onClose={onClose}
            width={1040}

            toolTask={TOOL_TASK}
            toolName={TOOL_TITLE}
            progressLabel={TOOL_PROGRESS_LABEL}

            taskSelector={selectAccountManagerUpdateTask}
            uuidSelector={selectAccountManagerUpdateUuid}

            setUuid={setUuid}
            setTask={setBackgroundTask}
            setResultShown={setShown}
            saveActionRequest={(assignAccountManagerRequest, options) => (
                apiDispatch(updateAccountManagerBulk({...options, assignAccountManagerRequest}))
            )}
            getProgress={id => apiDispatch(getUpdateRelationsProgress({id}))}
            stopAction={id => apiDispatch(stopBulkAction({id}))}

            stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}
            onDone={onDone}>
            {({onCloseModal, processAction}) => (
                <UpdateAccountTeamMemberModal {...{accountIds, onCloseModal, processAction}}/>
            )}
        </BulkActionTool>
    );
};
